export enum OfferState {
  Active = 1,
  Archived = 2,
  Deleted = 3,
}
